import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaPlusCircle, FaChartLine, FaClipboardCheck, FaFileAlt, FaDownload, FaUserCheck, FaCheckCircle } from 'react-icons/fa';
import { AuthContext } from '../../context/AuthContext';
import WorkStatsPanel from '../../components/reports/WorkStatsPanel';
import '../../components/common/DashboardQuickLinks.css';

const QUICK_LINKS = [
  { title: 'Assign Work', text: 'Allocate examiners to modules and exam centres.', path: '/archiver/allocate/assign', icon: <FaPlusCircle /> },
  { title: 'Allocation Progress', text: 'Monitor the status of every exam assignment.', path: '/archiver/allocate/progress', icon: <FaChartLine /> },
  { title: 'Review Uploads', text: 'Verify, approve, or reject exam uploads.', path: '/archiver/review', icon: <FaClipboardCheck /> },
  { title: 'Work Uploaded Report', text: 'See what has been uploaded so far.', path: '/archiver/reports/work-uploaded', icon: <FaFileAlt /> },
  { title: 'Students Work Download', text: 'Download candidates’ submitted work.', path: '/archiver/reports/students-work', icon: <FaDownload /> },
  { title: 'Candidate Work Status', text: 'Check submitted, empty, and absent status.', path: '/archiver/reports/candidate-work-status', icon: <FaUserCheck /> },
  { title: 'Completed Assignments', text: 'Browse assignments marked done.', path: '/archiver/completed', icon: <FaCheckCircle /> }
];

function ArchiverDashboard() {
  const { user } = useContext(AuthContext);

  return (
    <Container fluid className="archiver-dashboard py-5" style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <Row className="justify-content-center mb-4">
        <Col lg={8} md={10} sm={12} className="text-center">
          <h1 className="display-4 mb-3">Welcome, {user?.fullName || 'Archiver'}!</h1>
        </Col>
      </Row>
      <Row className="justify-content-center mb-4">
        <Col lg={10} md={12}>
          <WorkStatsPanel />
        </Col>
      </Row>
      <Row className="justify-content-center">
        {QUICK_LINKS.map((link) => (
          <Col md={4} sm={6} className="mb-4" key={link.path}>
            <Link to={link.path} className="text-decoration-none">
              <Card className="shadow-sm border-0 h-100 dashboard-quick-link">
                <Card.Body className="text-center">
                  <div className="h3 text-primary mb-2">{link.icon}</div>
                  <Card.Title className="h5 text-dark">{link.title}</Card.Title>
                  <Card.Text className="text-muted">{link.text}</Card.Text>
                </Card.Body>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default ArchiverDashboard;
